<template>
    <div class="w-full h-24 bg-secondary text-white flex items-center justify-between px-10">
        <div class="flex items-center">
            <span class="space" style="margin-left: 24rem;"></span>
            <p class="text-primary uppercase text-4xl font-black italic">PSO - {{ $store.state.branch.branch_name }}</p>
        </div>

        <DateTimeControl/>
    </div>
</template>

  
<script>
import DateTimeControl from '../controls/DateTimeControl.vue';

  export default {
    name: 'v-footer',
    components: {
        DateTimeControl
    }
  };
</script>
  
<style scoped>
@media (min-width: 2500px) {
 .h-24 {height: 8rem;}
 .space {margin-left: 30rem !important;}
}

</style>
  